import FormBase from "../../forms/FormBase";
import PersonalDataForm from "../../forms/shared/PersonalDataForm";
import AddressDataForm, { AddressType } from "../../forms/shared/AddressDataForm";
import VocationalTraningForm, {
  VocationalTraningFormItem,
} from "../../forms/shared/VocationalTraningForm";
import AcademicDegreeForm, {
  AcademicDegreeFormItem,
} from "../../forms/shared/AcademicDegreeForm";
import BusinessDataForm from "../../forms/shared/BusinessForm";
import AttachmentForm from "../../forms/medicoParceiro/AttachmentForm";
import PersonalAddressDataForm from "../../forms/medicoParceiro/PersonalAddressDataForm";
import TermsDeclarationsForm from "../../forms/medicoParceiro/TermsDeclarationsForm";
import GuideForm from "../../forms/shared/GuideForm";
import Professional from "../../models/Professional";
import { MedicoParceiroStepForm } from "../../config/MedicoParceiroStepForm";
import FormFieldBase from "../../forms/FormFieldBase";
import { FieldAttachment } from "../../forms/FormFieldAttachmentBase";
import ReducerBase, { SubTypeAttachment } from "./ReducerBase";

export interface IMedicoParceiroState {
  GuideForm: GuideForm;
  PersonalDataForm: PersonalDataForm;
  AddressDataForm: AddressDataForm;
  VocationalTraningForm: VocationalTraningForm;
  AcademicDegreeForm: AcademicDegreeForm;
  BusinessDataForm: BusinessDataForm;
  BusinessAddressDataForm: AddressDataForm;
  AttachmentForm: AttachmentForm;
  PersonalAddressDataForm: PersonalAddressDataForm;
  TermsDeclarationsForm: TermsDeclarationsForm;
  CurrentStep: number;
  MessageErrorToGoStep: string[];
  Loading: boolean;
  Professional: Professional;
  Protocol: string;
}

interface IUpdateForm {
  type: "UPDATE_FORM";
  payload: {
    form: FormBase;
    name: string;
    value: any;
  };
}

interface IUpdateFormAttachment {
  type: "UPDATE_FORM_ATTACHMENT";
  payload: {
    form: FormBase;
    name: string;
    value: FieldAttachment;
    errorMessage?: string;
    id?: string;
    loading?: boolean;
    subType: SubTypeAttachment;
  };
}

interface ICRUDFormVocationData {
  type: "CRUD_FORM_VOCATION_TRANING";
  payload: {
    subType: "InsertOrUpdate" | "Delete" | "Cancel" | "Edit";
    item?: VocationalTraningFormItem;
  };
}

interface ICRUDFormAcademicDegreeData {
  type: "CRUD_FORM_ACADEMIC_DEGREE";
  payload: {
    subType: "InsertOrUpdate" | "Delete" | "Cancel" | "Edit";
    item?: AcademicDegreeFormItem;
  };
}

interface IGoToNextStep {
  type: "GO_TO_NEXT_STEP";
  payload: { messagesError: string[] };
}

interface IGoToBackStep {
  type: "GO_TO_BACK_STEP";
}

interface IProcessingInfo {
  type: "LOADING";
  payload: { processing: boolean };
}
interface ISetProfessionalId {
  type: "SET_PROFESSIONAL";
  payload: {
    response: any;
  };
}
interface ISetProtocol {
  type: "SET_PROTOCOL";
  payload: {
    response: any;
  };
}

interface IResetState {
  type: "RESET_STATE";
}

export type Actions =
  | IUpdateForm
  | IGoToNextStep
  | IGoToBackStep
  | ICRUDFormVocationData
  | ICRUDFormAcademicDegreeData
  | ISetProfessionalId
  | ISetProtocol
  | IProcessingInfo
  | IUpdateFormAttachment
  | IResetState;

export const initialState: IMedicoParceiroState = {
  GuideForm: GuideForm.NewInstance(),
  PersonalDataForm: PersonalDataForm.NewInstance(),
  AddressDataForm: AddressDataForm.NewInstance(AddressType.PERSONAL),
  VocationalTraningForm: VocationalTraningForm.NewInstance(),
  AcademicDegreeForm: AcademicDegreeForm.NewInstance(),
  BusinessDataForm: BusinessDataForm.NewInstance(),
  BusinessAddressDataForm: AddressDataForm.NewInstance(AddressType.BUSINESS),
  AttachmentForm: AttachmentForm.NewInstance(),
  PersonalAddressDataForm: PersonalAddressDataForm.NewInstance(),
  TermsDeclarationsForm: TermsDeclarationsForm.NewInstance(),
  CurrentStep: 1,
  MessageErrorToGoStep: [],
  Loading: false,
  Professional: Professional.NewInstance(),
  Protocol: "",
};

export const reducer = (state: IMedicoParceiroState, action: Actions) => {
  switch (action.type) {
    case "UPDATE_FORM": {
      const { form, name, value } = action.payload;

      (form.GetFieldByName(name) as FormFieldBase).Value = value;
      (form.GetFieldByName(name) as FormFieldBase).InputChange(value);
      (form.GetFieldByName(name) as FormFieldBase).ValidateField();

      return { ...state };
    }

    case "UPDATE_FORM_ATTACHMENT": {
      const { form, name, value, subType, id, errorMessage, loading } = action.payload;

      ReducerBase.updateFileActions(form, name, value, subType, errorMessage, id, loading);


      return { ...state };
    }

    case "SET_PROFESSIONAL": {
      const { response } = action.payload;

      let professional = new Professional(response.encriptId, response.name);

      return { ...state, Professional: professional };
    }
    case "SET_PROTOCOL": {
      const { response } = action.payload;

      return { ...state, Protocol: response.protocol };
    }

    case "CRUD_FORM_VOCATION_TRANING": {
      const { subType, item } = action.payload;

      if (subType === "InsertOrUpdate") {
        state.VocationalTraningForm.AddOrUpdateVocationalTraningFormItem();
      } else if (subType === "Edit") {
        state.VocationalTraningForm.EditVocationalTraningFormItem(
          item?.Id || 0
        );
      } else if (subType === "Delete") {
        state.VocationalTraningForm.RemoveVocationalTraningFormItem(
          item?.Id || 0
        );
      } else if (subType === "Cancel") {
        state.VocationalTraningForm.ResetForm();
      }

      return { ...state };
    }

    case "CRUD_FORM_ACADEMIC_DEGREE": {
      const { subType, item } = action.payload;

      if (subType === "InsertOrUpdate") {
        state.AcademicDegreeForm.AddOrUpdateAcademicDegreeFormItem();
      } else if (subType === "Edit") {
        state.AcademicDegreeForm.EditAcademicDegreeFormItem(item?.Id || 0);
      } else if (subType === "Delete") {
        state.AcademicDegreeForm.RemoveAcademicDegreeFormItem(item?.Id || 0);
      } else if (subType === "Cancel") {
        state.AcademicDegreeForm.ResetForm();
      }

      return { ...state };
    }

    case "GO_TO_NEXT_STEP": {
      const { messagesError } = action.payload;

      //Se houver mensagens de erro, não pode avançar a etapa
      if (messagesError.length === 0) {
        if (state.CurrentStep < MedicoParceiroStepForm.length) {
          return {
            ...state,
            CurrentStep: state.CurrentStep + 1,
            MessageErrorToGoStep: [],
          };
        }
      } else {
        return { ...state, MessageErrorToGoStep: messagesError };
      }

      return { ...state };
    }

    case "GO_TO_BACK_STEP":
      if (state.CurrentStep > 1) {
        return {
          ...state,
          CurrentStep: state.CurrentStep - 1,
          MessageErrorToGoStep: [],
        };
      }
      return { ...state };

    case "LOADING":
      const { processing: loading } = action.payload;

      return { ...state, Loading: loading };

    case "RESET_STATE":

      return {
        ...state,
        GuideForm: GuideForm.NewInstance(),
        PersonalDataForm: PersonalDataForm.NewInstance(),
        AddressDataForm: AddressDataForm.NewInstance(AddressType.PERSONAL),
        VocationalTraningForm: VocationalTraningForm.NewInstance(),
        AcademicDegreeForm: AcademicDegreeForm.NewInstance(),
        BusinessDataForm: BusinessDataForm.NewInstance(),
        BusinessAddressDataForm: AddressDataForm.NewInstance(AddressType.BUSINESS),
        AttachmentForm: AttachmentForm.NewInstance(),
        PersonalAddressDataForm: PersonalAddressDataForm.NewInstance(),
        TermsDeclarationsForm: TermsDeclarationsForm.NewInstance(),
        CurrentStep: 1,
        MessageErrorToGoStep: [],
        Loading: false,
        Professional: Professional.NewInstance(),
        Protocol: "",
      };

    default:
      return { ...state };
  }
};

export function getStateFormPropertyByName(
  name: string,
  state: IMedicoParceiroState
): any {
  switch (name) {
    case "GuideForm":
      return state.GuideForm;
    case "PersonalDataForm":
      return state.PersonalDataForm;
    case "AddressDataForm":
      return state.AddressDataForm;
    case "BusinessDataForm":
      return state.BusinessDataForm;
    case "BusinessAddressDataForm":
      return state.BusinessAddressDataForm;
    case "AttachmentForm":
      return state.AttachmentForm;
    case "VocationalTraningForm":
      return state.VocationalTraningForm;
    case "AcademicDegreeForm":
      return state.AcademicDegreeForm;
    case "PersonalAddressDataForm":
      return state.PersonalAddressDataForm;
    case "TermsDeclarationsForm":
      return state.TermsDeclarationsForm;
    default:
      console.error(`O Formulário ${name} não está mapeando no reducer`);
      break;
  }
}
